import { useCallback } from 'react'
import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import { ConfirmDialog } from 'civic-champs-shared/core/confirm-dialog/'
import { useRemoveTag } from './useRemoveTag'

export const useRemoveTagPrompt = (eagerRemove: any) => {
  const showPrompt = useShowPrompt(ConfirmDialog)
  const removeTag = useRemoveTag(eagerRemove)

  return useCallback(
    async tag => {
      const text = `Are you sure you want to delete "${tag.name}"? The action can not be undone.`
      const confirmed = await showPrompt({
        text,
        title: 'Delete Tag',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        type: 'warning',
      })

      if (confirmed) {
        await removeTag(tag)
      }
    },
    [showPrompt, removeTag],
  )
}

export default useRemoveTagPrompt
